import { StompActionskeys } from "../stomp-broker";
import { Observable } from "rxjs/Observable";
import { combineLatest } from "rxjs/observable/combineLatest";
export function mergeActions(disconnected, change) {
    return Observable.merge(change, disconnected);
}
export function whenConnected(actions$, actionType) {
    const stream$ = combineLatest(Observable.merge(actions$.ofType(StompActionskeys.CONNECTED), actions$.ofType(StompActionskeys.DISCONNECTED)), actions$.ofType(actionType)).filter(([value, _]) => value.type === StompActionskeys.CONNECTED);
    return stream$;
}
//# sourceMappingURL=subscription.js.map